import React from "react";
import { Box, Paper, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { SelectMusicArchiveType } from './select-client';
var useStyles = makeStyles({
    iconButton: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
    },
});
export var Form = function (_a) {
    var client = _a.client, 
    // published,
    type = _a.type, handlers = _a.handlers;
    var ref = React.createRef();
    return (React.createElement("form", { onSubmit: handlers.submit.do },
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Box, null,
                React.createElement(SelectMusicArchiveType, { client: client, type: type })),
            React.createElement(Box, { mt: 1, display: "flex", alignItems: "flex-end" },
                React.createElement(ButtonLoader, { variant: "contained", color: "primary", type: "submit", isLoading: handlers.submit.pending }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
};
